import React from 'react';
import { X, Lock, ExternalLink } from 'lucide-react';
import { Button } from './button';

interface PDFUnlockTipModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void; // 繼續上傳功能
}

const PDFUnlockTipModal: React.FC<PDFUnlockTipModalProps> = ({
  isOpen,
  onClose,
  onContinue,
}) => {
  if (!isOpen) return null;

  const handleGoToUnlock = () => {
    window.open('https://www.ilovepdf.com/unlock_pdf', '_blank');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl p-6 mx-4 max-w-md w-full shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(59, 130, 246, 0.1)' }}>
              <Lock className="w-5 h-5 text-blue-600" />
            </div>
            <h2 className="text-xl font-semibold" style={{ color: 'var(--charcoal)' }}>
              PDF需要解鎖
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-100 transition-colors"
          >
            <X className="w-5 h-5" style={{ color: 'var(--medium-gray)' }} />
          </button>
        </div>

        {/* Content */}
        <div className="mb-6">
          <p className="text-sm leading-relaxed mb-4" style={{ color: 'var(--medium-gray)' }}>
            您上傳的PDF文件受到密碼保護，系統無法直接分析加密的PDF文件。
          </p>
          <p className="text-sm leading-relaxed mb-4" style={{ color: 'var(--medium-gray)' }}>
            請先使用以下工具解鎖PDF文件，然後再重新上傳：
          </p>
          <div className="bg-blue-50 rounded-lg p-4 mb-4">
            <div className="flex items-center gap-2 mb-2">
              <ExternalLink className="w-4 h-4 text-blue-600" />
              <a
                href="https://www.ilovepdf.com/unlock_pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-medium text-blue-600 hover:text-blue-700 underline"
              >
                iLovePDF - 解鎖PDF工具
              </a>
            </div>
            <p className="text-xs text-gray-600">
              點擊上方連結前往解鎖工具，解鎖後再上傳保單文件
            </p>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex">
          <Button
            onClick={onContinue}
            className="w-full"
            style={{
              background: 'var(--charcoal)',
              border: 'none',
              borderRadius: '12px'
            }}
          >
            繼續上傳保單
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PDFUnlockTipModal;

